import React, { useEffect, useState } from 'react';
import GlimpsesBg from '../assets/images/glimpses-bg.png';
import { Container,Row,Col,Card,Placeholder } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
const Glimpses = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[Glimpse,setGlimpse]=useState([]);
    const[isLoading, setLoading] = useState(true);
    useEffect(()=>
    {
        const GlimpsesAll = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"glimpses/all");
                const result = await response.json();
                if( result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sg_id + "/sgPhoto")
                                .then(up => up.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sg_id + "/sgPhotoHi")
                                .then(uph => uph.json());
                            const fetch3 = fetch(global.config.API_URL + "upload/details/0/"+e.sg_id+"/siteGlimpses")
                                .then(ud => ud.json());
                            return Promise.all([fetch1, fetch2, fetch3])
                                .then(([ups, upsh,uds]) => {
                                    return {
                                        ...e,
                                        ups,
                                        upsh,
                                        uds
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].sgPhoto = (el.ups.length > 0) ? global.config.uploadPath + el.ups[0].up_fname + el.ups[0].up_ext : '';
                            result[i].sgPhotoHi = (el.upsh.length > 0) ? global.config.uploadPath + el.upsh[0].up_fname + el.upsh[0].up_ext : '';
                            result[i].siteGlimpses = el.uds.length;
                        });
                        setGlimpse(result);
                        setLoading(false);
                    }).catch(error => {
                        console.error('GlimpsesAll File :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setGlimpse([]);
                    setLoading(false);
                }
                if( global.config.IsPrint === true ) { console.info('GlimpsesAll : Result',result); }
            }
            catch (error) 
            {
                console.error('GlimpsesAll : Error', error.message);
            }
        };
        GlimpsesAll();
    },[])
    return (
        <Container fluid className='py-3 py-md-5 px-0' style={{backgroundImage:"url("+GlimpsesBg+")"}}>
            <Container>
            {isLoading ? (
                <Row className='row-cols-1 row-cols-sm-2 row-cols-md-3 g-3 '>
                {[...Array(12)].map((_,index)=>(
                <Col key={index}>
                    <Card className='bg-secondary-subtle text-center'>
                        <Card.Header className='text-center fs-4' data-aos="flip-up" data-aos-duration="1500"><Placeholder xs={10} /></Card.Header>
                        <Card.Body>
                            <Placeholder xs={12} style={{height:"150px"}} className="img-fluid rounded border border-3 mb-3" />
                            <span className='btn btn-info w-50'><Placeholder xs={10} /></span>
                        </Card.Body>
                    </Card>
                </Col>
                ))}
                </Row>
            ) : (
                <Row className='row-cols-1 row-cols-sm-2 row-cols-md-3 g-3 '>
                {Glimpse.map((sg,index)=>( 
                    <Col key={index}>
                        <Card className='bg-secondary-subtle text-center h-100'>
                            <Card.Header className='text-center fs-5 text-uppercase' data-aos="flip-up" data-aos-duration="1500">
                                {appLanguage === 'hi' ? (sg.sg_display_en === "1" ? sg.sg_name_hi || '' : sg.sg_name_hi || sg.sg_name) : sg.sg_name} ({sg.siteGlimpses} {appLanguage === 'hi' ? 'तस्वीरें' : 'Photos'})
                            </Card.Header>
                            <Card.Body>
                                {appLanguage === 'hi' ? 
                                    (
                                        sg.sg_display_en === "1" && sg.sgPhotoHi 
                                        ? <Card.Img src={sg.sgPhotoHi} className='img-fluid rounded border border-3' /> 
                                        : sg.sgPhotoHi 
                                            ? <Card.Img src={sg.sgPhotoHi} className='img-fluid rounded border border-3' /> 
                                            : sg.sgPhoto
                                            ? <Card.Img src={sg.sgPhoto} className='img-fluid rounded border border-3' />
                                            : ''
                                    ) : (
                                        sg.sgPhoto 
                                        ? <Card.Img src={sg.sgPhoto} className='img-fluid rounded border border-3' />
                                        : ''
                                    )
                                }                                
                                {sg.siteGlimpses > 0 && 
                                <NavLink className='btn btn-info mt-3' to={appLanguage === 'hi' ? `/झलकियाँ/विवरण/${sg.sg_htaccess_hi || sg.sg_htaccess}` : `/glimpses/details/${sg.sg_htaccess}`} target='_blank' rel="noopener noreferrer">
                                    {appLanguage === 'hi' ? 'और देखें' : 'SEE MORE'}
                                </NavLink>}
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
                </Row>
            )}
            </Container>
        </Container>
    );
}
export default Glimpses;